import React from "react";
import ConsentManager from "./src/components/consent/ConsentManager";
import "./src/styles/cookie-consent.scss";

export const wrapRootElement = ({ element }) => (
  <>
    <ConsentManager />
    {element}
  </>
);
